import { render, staticRenderFns } from "./EditBillingSettingsTemplate.vue?vue&type=template&id=770f0453"
import script from "./EditBillingSettingsTemplate.vue?vue&type=script&lang=js"
export * from "./EditBillingSettingsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports